var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.799805C9.39599 0.799805 0.799988 9.39581 0.799988 19.9998C0.799988 30.6038 9.39599 39.1998 20 39.1998C30.604 39.1998 39.2 30.6038 39.2 19.9998C39.2 9.39581 30.604 0.799805 20 0.799805ZM27.81 16.5278C27.818 16.6918 27.82 16.8558 27.82 17.0158C27.82 22.0158 24.018 27.7778 17.062 27.7778C15.0066 27.7812 12.9939 27.1909 11.266 26.0778C11.56 26.1138 11.862 26.1278 12.168 26.1278C13.94 26.1278 15.57 25.5258 16.864 24.5098C16.0754 24.4943 15.3113 24.2332 14.6782 23.7628C14.0451 23.2925 13.5745 22.6363 13.332 21.8858C13.8983 21.9935 14.4817 21.9709 15.038 21.8198C14.1821 21.6467 13.4124 21.183 12.8594 20.5071C12.3064 19.8313 12.0042 18.985 12.004 18.1118V18.0658C12.514 18.3478 13.098 18.5198 13.718 18.5398C12.9156 18.0057 12.3476 17.1851 12.1301 16.2461C11.9126 15.307 12.0621 14.3203 12.548 13.4878C13.4979 14.6558 14.6825 15.6113 16.0251 16.2924C17.3677 16.9736 18.8384 17.3651 20.342 17.4418C20.1508 16.6304 20.2331 15.7786 20.576 15.0188C20.9189 14.259 21.5032 13.6338 22.2381 13.2403C22.973 12.8469 23.8173 12.7073 24.6398 12.8431C25.4622 12.979 26.2167 13.3829 26.786 13.9918C27.6323 13.8244 28.4439 13.5139 29.186 13.0738C28.9039 13.9501 28.3133 14.6942 27.524 15.1678C28.2737 15.0775 29.0057 14.876 29.696 14.5698C29.189 15.3296 28.5503 15.9927 27.81 16.5278V16.5278Z",
    fill: "url(#paint0_linear_944_337)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_337",
    x1: 39.2,
    y1: 19.6507,
    x2: 0.799988,
    y2: 19.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505591,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon1);
export default __webpack_public_path__ + "static/media/footer_icon_1.3844aed01e3359ca68024afa191da52b.svg";
export { ForwardRef as ReactComponent };